// Copyright (c) 2025 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  GetTrainingNarrativeRequestSchema,
  ListTrainingGroupsRequestSchema,
  SetNarratePreferencesRequestSchema,
} from "../../generated/wisetime/user/assistant/v4/preferences_pb"
import { Init } from "../../app/rpc"

export const getDefaultNarratePreferences = createAction("narrate-preferences/get-default-narrate-preferences")
export const getSavedNarratePreferences = createAction("narrate-preferences/get-saved-narrate-preferences")
export const setNarratePreferences = createAction<Init<typeof SetNarratePreferencesRequestSchema>>("narrate-preferences/set-narrate-preferences")
export type ListTrainingGroupsPayload = {
  request: Init<typeof ListTrainingGroupsRequestSchema>,
  replaceGroupId?: string,
}
export const listTrainingGroups = createAction<ListTrainingGroupsPayload>("narrate-preferences/list-training-groups")
export const getTrainingNarrative = createAction<Init<typeof GetTrainingNarrativeRequestSchema>>("narrate-preferences/get-training-narrative")
